// 分账通
const trendData = {
    path: 'distribute',
    component: () => import('@/components/RouterView'),
    meta: {title: '分账通'},
    redirect: '/manage/distribute/initiate',
    children: [
        {
            path: 'initiate',
            component: () => import('@/views/manage/distribute/initiate'),
            meta: {title: '我发起的分账'},
        },
        {
            path: 'receive',
            component: () => import('@/views/manage/distribute/receive'),
            meta: {title: '我收到的分账'},
        },
        {
            path: 'detail',
            component: () => import('@/components/RouterView'),
            meta: {title: '分账详情'},
            redirect: '/manage/distribute/detail/1',
            children: [
                {
                    path: '1',
                    component: () => import('@/views/manage/distribute/detail/step1'),
                    meta: {title: '发起分账'},
                },
                {
                    path: '3',
                    component: () => import('@/views/manage/distribute/detail/step3'),
                    meta: {title: '完成分账'},
                },
            ],
        },
        {
            path: 'stop',
            component: () => import('@/views/manage/distribute/components/stopRule')
        }
    ],
};

export default trendData;
